import { ReactElement } from "react";
import BorderedNavbar from "../general/nav/BorderedNavbar";
import GeneralLayout from "./GeneralLayout";

const BorderedNavLayout = ({children}: any) => {

  return (
    <>
      <BorderedNavbar/>
      <main>{children}</main>
    </>
  );
};

BorderedNavLayout.getLayout = function getLayout(page: ReactElement) {
  return <GeneralLayout>{page}</GeneralLayout>;
};

export default BorderedNavLayout;
